import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'What styles do you specialize in?',
  answer: 'We specialize in all braid styles including knotless braids, box braids, cornrows, goddess braids, and more.'
}, {
  question: 'How do I book an appointment?',
  answer: 'You can book by calling us at (240) 921-7857 or via Instagram DM.'
}, {
  question: 'Is the deposit refundable?',
  answer: 'No, we require a $25 non-refundable deposit to secure your slot.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-warm-brown text-cream" data-id="element-66">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-67">
        <div className="text-center mb-16" data-id="element-68">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mb-6" data-id="element-69">
            Common Questions
          </h2>
          <div className="w-16 h-px bg-brand-gold mx-auto" data-id="element-70"></div>
        </div>
        <div className="space-y-4" data-id="element-71">
          {faqs.map((faq, index) => <div key={index} className="border-b border-cream/10" data-id="element-72">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full py-6 flex justify-between items-center text-left group" data-id="element-73">
                <span className="font-display text-xl md:text-2xl group-hover:text-brand-gold transition-colors" data-id="element-74">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-brand-gold transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-75" />
              </button>
              <AnimatePresence data-id="element-76">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} data-id="element-77">
                    <p className="pb-6 text-cream/70 font-body leading-relaxed" data-id="element-78">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}